import { takeLatest, put } from 'redux-saga/effects';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import {
  actionSetGridDataInvalid,
  actionSetGridDataValid,
} from 'react-redux-app/lib/modules/grid/actions';

import { getPageGridName } from '../../utils/pageGrid';

import {
  ACTION_ADD_PAGE_CONTENT__REQUEST,
  ACTION_ADD_PAGE_CONTENT__SUCCESS,
  ACTION_ADD_PAGE_CONTENT__FAIL,

  ACTION_DELETE_PAGE__REQUEST,
  ACTION_DELETE_PAGE__SUCCESS,
  ACTION_DELETE_PAGE__FAIL,

  ACTION_DELETE_PAGE_CONTENT__REQUEST,
  ACTION_DELETE_PAGE_CONTENT__SUCCESS,
  ACTION_DELETE_PAGE_CONTENT__FAIL,

  ACTION_EDIT_PAGE_CONTENT__REQUEST,
  ACTION_EDIT_PAGE_CONTENT__SUCCESS,
  ACTION_EDIT_PAGE_CONTENT__FAIL,

  ACTION_EDIT_PAGE_NAME__REQUEST,
  ACTION_EDIT_PAGE_NAME__SUCCESS,
  ACTION_EDIT_PAGE_NAME__FAIL,
} from '../../actionTypes';


function* enableGrid(action) {
  try {
    const { pageId } = action.payload;

    yield put(actionSetGridDataValid(getPageGridName(pageId)));
  } catch (e) {
    yield put(actionAddException(e));
  }
}

function* disableGrid(action) {
  try {
    const { pageId } = action.payload;

    yield put(actionSetGridDataInvalid(getPageGridName(pageId)));
  } catch (e) {
    yield put(actionAddException(e));
  }
}

export default function* saga() {
  yield takeLatest([
    ACTION_ADD_PAGE_CONTENT__REQUEST,
    ACTION_DELETE_PAGE__REQUEST,
    ACTION_DELETE_PAGE_CONTENT__REQUEST,
    ACTION_EDIT_PAGE_NAME__REQUEST,
    ACTION_EDIT_PAGE_CONTENT__REQUEST,
  ], disableGrid);

  yield takeLatest([
    ACTION_ADD_PAGE_CONTENT__SUCCESS,
    ACTION_ADD_PAGE_CONTENT__FAIL,
    ACTION_DELETE_PAGE__SUCCESS,
    ACTION_DELETE_PAGE__FAIL,
    ACTION_DELETE_PAGE_CONTENT__SUCCESS,
    ACTION_DELETE_PAGE_CONTENT__FAIL,
    ACTION_EDIT_PAGE_NAME__SUCCESS,
    ACTION_EDIT_PAGE_NAME__FAIL,
    ACTION_EDIT_PAGE_CONTENT__SUCCESS,
    ACTION_EDIT_PAGE_CONTENT__FAIL,
  ], enableGrid);
}
